/* eslint-disable react/no-danger */
/* eslint-disable max-len */
import { Link } from 'gatsby';
import _, { isEmpty } from 'lodash';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Sprites from '../components/Sprites';

export default function FreeZoneTwoColumnsTextContentWithImage({ data, id, dir }) {
  const {
    title,
    text,
    intro,
    image,
    leftBackgroundImage,
    rightBackgroundImage,
    allLinkes,
    reverseColumn,
    textDisclaimer,
    lists,
    expoVillageLink,
    linkLabel,
    sectionID,
    extraCSSClassName,
    mobileImage,
    cTAClassName,
  } = data;
  const isFreeZoneLicenses =
    typeof window !== 'undefined' && _.includes(window.location.pathname, 'free-zone-licenses');

  // console.log(linkLabel);

  return (
    <section
      id={sectionID === null ? id : sectionID}
      className={`${extraCSSClassName ? 'pb-[180px] lg:pb-[170px]' : ''} bg-[#fafafa]`}>
      <div className={`flex flex-col  ${reverseColumn ? 'md:flex-row-reverse' : 'md:flex-row'}`}>
        <div
          className={`md:w-1/2 ${expoVillageLink !== null ? 'pt-[40px]' : 'py-[40px]'} md:py-[72px] flex flex-col 
          justify-center relative overflow-hidden
          ${
            reverseColumn
              ? 'md:items-start ltr:md:pl-10 ltr:xl:pl-[107px] rtl:md:pr-10 rtl:xl:pr-[107px]'
              : 'md:items-end ltr:md:pr-10 ltr:xl:pr-[107px] rtl:md:pl-10 rtl:xl:pl-[107px]'
          }
          `}>
          {isEmpty(leftBackgroundImage) || (
            <LazyLoadImage
              src={leftBackgroundImage.url}
              fill
              className="left-0 right-0 bottom-0 top-0 absolute w-full h-full object-cover z-10"
            />
          )}
          <div className="flex flex-col gap-y-[25px] md:gap-y-[50px] max-w-[722px] relative z-20">
            <div className="flex flex-col gap-y-5 md:gap-y-[30px] max-w-[662px] px-6 3xl:px-0">
              <div className="flex flex-col gap-y-5">
                <div
                  dangerouslySetInnerHTML={{ __html: title }}
                  className="text-clamp20to40  h2-child:text-clamp20to40 text-[#4A4A4A]
                  h2-child:leading-[1.2] h2-child:m-0"
                />
                <div className="h-[2px] w-[50px] bg-[#CE445B]" />
              </div>
              {_.isEmpty(intro) || (
                <div className="text-[#4D4D4D] text-clamp16to20 font-normal leading-1.6 ltr:font-LibreBaskervilleRegular rtl:font-GESSTwoDWTLight  max-w-[520px] md:pt-[10px]">
                  {intro}
                </div>
              )}
              <div
                dangerouslySetInnerHTML={{ __html: text }}
                className="p-child:text-[#4A4A4A] p-child:text-clamp14to18 p-child:font-normal
              p-child:leading-1.4 p-child:mb-0 p-child:ltr:font-URWDINRegular p-child:rtl:font-GESSTwoDWTCLight max-w-[582px] flex
              flex-col gap-y-4 lg:gap-y-6 [&>*>a]:text-[#CE445B] [&>*>a]:underline hover:[&>*>a]:no-underline
              h6-child:max-w-[445px] h6-child:text-[#333333] h6-child:font-URWDINMedium h6-child:font-normal h6-child:text-clamp14to18
                  p-a-child:text-red p-a-child:underline tax-class:ltr:w-[85%] tax-class:font-URWDINMedium
                  tax-class:text-[#333]"
              />
              {_.isEmpty(lists) || (
                <div className="flex flex-col gap-y-5 pt-[10px]">
                  {_.map(lists, (list, listIndex) => (
                    <div key={listIndex} className="flex flex-row gap-x-[15px] md:gap-x-5">
                      <Sprites
                        name="tick"
                        className="w-[15px] md:w-[25px] min-w-[15px] md:min-w-[25px]
                              h-[15px] md:h-[25px] fill-[#CE445B] relative top-[2px] lg:top-[-4px]"
                      />
                      <span
                        className="text-clamp13to16 
                        ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight 
                        rtl:pt-[2px] rtl:md:pt-0
                        ltr:leading-1 rtl:leading-[1.3]
                        text-[#4D4D4D]">
                        {list}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {isEmpty(allLinkes) || (
              <div className="flex flex-row flex-wrap gap-4 3xl:gap-6 px-6 3xl:px-0">
                {allLinkes.length === 1
                  ? _.map(allLinkes, (link, index) => (
                      <div
                        className={`
                      ${isFreeZoneLicenses ? 'w-fit' : 'w-full md:w-fit '}
                      `}
                        key={index}>
                        {_.isEmpty(link) || (
                          <Link
                            href={link.url}
                            target={link.target}
                            className={`${cTAClassName !== null ? cTAClassName : ''} w-auto md:w-fit
                            inline-flex md:flex justify-center items-center rounded-[48px]
                            bg-[#CE445B] hover:bg-[#B53B50] text-white 
                            uppercase ltr:font-URWDINBold 
                            rtl:font-GESSTwoDWTCMedium mx-auto ltr:tracking-[0.96px] leading-1.5 md:leading-1.25
                            min-h-[40px] md:h-[51px] text-center px-12 md:px-14 py-2
                            rtl:text-[12px] ltr:text-[11px] rtl:md:text-[16px] ltr:md:text-[15px] 
                            rtl:lg:text-[18px]
                            md:py-5 rtl:pt-[10px] ltr:pt-[12px] ltr:md:pt-6 rtl:md:pt-5 `}
                            dir={dir} dangerouslySetInnerHTML={{__html:link.name }} />
                        )}
                      </div>
                    ))
                  : <div className='flex flex-row flex-wrap gap-4'>
                  {_.map(allLinkes, (link, index) => (
                    <div className="w-full md:w-fit" key={index}>
                    {_.isEmpty(link) || (
                      <Link
                        href={link.url}
                        target={link.target}
                        className={` text-[#4D4D4D] border-[#4D4D4D] 
                        hover:bg-[#CE445B] hover:text-white border hover:border-[#CE445B]
                        w-full md:w-fit inline-flex md:flex justify-center items-center
                        rounded-[48px] uppercase ltr:font-URWDINBold rtl:font-GESSTwoDWTCMedium mx-auto ltr:tracking-[0.96px] leading-1.5 md:leading-1.25
                        min-h-8 text-[11px] md:text-[13px] text-center px-12 md:px-7 py-2 
                        md:py-5 rtl:pt-[10px] ltr:pt-[11px] ltr:md:pt-[26px] rtl:md:pt-5 md:h-10
                        ${index===0?'bg-[#CE445B] text-white border-[#CE4458]':'bg-white'}
                        `}
                        dir={dir} dangerouslySetInnerHTML={{__html:link.name}} />
                    )}
                  </div>
                ))}
                </div>}
              </div>
            )}
            {_.isEmpty(expoVillageLink) || (
              <div className="w-full md:w-fit px-6 3xl:px-0">
                <Link
                  href={expoVillageLink.url}
                  target={expoVillageLink.target}
                  className={`${cTAClassName !== null ? cTAClassName : ''} inline-flex justify-center items-center
                    rounded-[4px] ltr:font-URWDINRegular rtl:font-GESSTwoDWTCMedium gap-[10px] mb-10 md:mb-auto
                    ltr:leading-1 rtl:leading-1.3 h-[77px] rtl:text-[15px] ltr:text-[18px] pt-1
                    md:rtl:text-[18px] md:ltr:text-[20px] lg:rtl:text-[23px] lg:ltr:text-[25px] px-6 md:px-8 lg:px-10 xl:px-14 bg-[#CE445B] hover:bg-[#B53B50] text-white`}>
                  {linkLabel ? (
                    <span
                      className="[&>*]:text-white [&>*]:m-0 [&>p>strong]:!font-URWDINBold
                      rtl:font-GESSTwoDWTCMedium"
                      dangerouslySetInnerHTML={{ __html: expoVillageLink.name }}
                    />
                  ) : (
                    <span dangerouslySetInnerHTML={{__html:expoVillageLink.name}} />
                  )}
                    <Sprites name="arrow-rounded-next" className="rtl:scale-[-1]"/>
                </Link>
              </div>
            )}

            {_.isEmpty(textDisclaimer) || (
              <p
                className="text-clamp12to15 ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight text-[#4A4A4A] leading-1.5 mt-[-10px]
                md:mt-[-20px] max-w-[570px] !mb-0 px-6">
                {textDisclaimer}
              </p>
            )}
          </div>
        </div>
        <div
          className={`md:w-1/2 min-h-full [&>span]:h-full relative overflow-hidden ${rightBackgroundImage !== null ? 'p-[40px] md:p-[72px] xl:p-[72px]' : ''}`}>
          {isEmpty(rightBackgroundImage) || (
            <LazyLoadImage
              src={rightBackgroundImage.url}
              width="100%"
              fill
              className="left-0 right-0 bottom-0 top-0 absolute w-full h-full object-cover z-0"
            />
          )}

          {isEmpty(image) || (
            <div className="hidden md:block h-full relative">
              {!isEmpty(rightBackgroundImage) || (
                <>
                  <div
                    className={`hidden md:block ${reverseColumn ? 'image-gradient-right' : 'image-gradient-left'}`}
                  />
                  <div className="block md:hidden image-gradient-top" />
                </>
              )}
              <LazyLoadImage
                src={image.url}
                width="100%"
                fill
                className={`${rightBackgroundImage !== null ? 'max-w-[724px] mx-auto object-contain h-[160px] md:h-full' : 'w-full h-full object-cover'} relative z-30`}
              />
            </div>
          )}
          {isEmpty(mobileImage) ? (
            <div className="md:hidden h-full relative">
              {isEmpty(image) || (
              <LazyLoadImage
                src={image.url}
                width="100%"
                fill
                className={`${rightBackgroundImage !== null ? 'max-w-[724px] mx-auto object-contain h-[160px] md:h-full' : 'w-full h-full object-cover'} relative z-30`}
              />
              )}
            </div>
          ) : (
            <div className="md:hidden h-full relative">
               <div className={`${expoVillageLink !== null ? 'hidden' : 'block'} md:hidden image-gradient-top`} />
              <LazyLoadImage
                src={mobileImage.url}
                width="100%"
                fill
                className={`${rightBackgroundImage !== null ? 'max-w-[724px] mx-auto object-contain h-[160px] md:h-full' : 'w-full h-full object-cover'} relative z-30`}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
